import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  DateField,
  useListContext,
  ListContextProvider,
  useRefresh,
  Datagrid,
} from 'react-admin';

import { Card, Divider, Tabs, Tab } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils';
//import ActionsField from './ActionsField';
import { PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateEdit from './DialogoCreateEdit';
import DialogoDeletar from './DialogoDeletar';
import DialogoShow from './DialogoShow';
import Filter from './Filter';
import StatusField from './StatusField';

const tabs = [
  { id: 'trabalhando', name: 'trabalhando' },
  { id: 'arquivado', name: 'arquivado' },
];

//
const MyList = ({ ...props }) => {
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [confirmados, setConfirmados] = useState([]);
  const [cancelados, setCancelados] = useState([]);

  const refDialogoCreateEdit = useRef(null);
  const refDialogoDeletar = useRef(null);
  const refDialogoShow = useRef(null);

  const refresh = useRefresh();

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setConfirmados(ids);
          break;
        case STATUS_INATIVO:
          setCancelados(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'trabalhando' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  function handleCriar() {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleCreate();
    }
  }

  function handleShow({ id }) {
    if (refDialogoShow.current) {
      refDialogoShow.current.handleOpen(id);
    }
  }

  function handleEdit({ id }) {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleEdit(id);
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoDeletar.current) {
      refDialogoDeletar.current.handleOpen(id);
    }
  }

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: confirmados }}>
              <Datagrid {...props}>
                <StatusField source="nome" label="Status" sortable={false} />
                <TextField source="nome" label="Descrição" sortable={false} />
                <ActionsField
                  source="lalala"
                  /*  handleEdit={handleEdit}
                  handleDeletar={handleDeletar}
                  handleShow={handleShow} */
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  actions={[
                    {
                      key: 'edit',
                      title: 'Editar',
                      icon: <EditIcon />,
                      onClick: (rec) => handleEdit(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: () => false,
                    },
                    {
                      key: 'show',
                      title: 'Detalhes',
                      icon: <VisibilityIcon />,
                      onClick: (rec) => handleShow(rec),
                      show: () => true,
                      disabled: () => false,
                    },
                    {
                      key: 'delete',
                      title: 'Deletar',
                      icon: <DeleteIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: () => false,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: cancelados }}>
              <Datagrid {...props}>
                <StatusField source="nome" label="Status" sortable={false} />
                <TextField source="nome" label="Descrição" sortable={false} />
                <DateField source="data" label="Data" showTime />
                <ActionsField
                  source="lalala"
                  /* handleEdit={handleEdit}
                  handleDeletar={handleDeletar}
                  handleShow={handleShow} */
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  actions={[
                    {
                      key: 'edit',
                      title: 'Editar',
                      icon: <EditIcon />,
                      onClick: (rec) => handleEdit(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: () => false,
                    },
                    {
                      key: 'show',
                      title: 'Detalhes',
                      icon: <VisibilityIcon />,
                      onClick: (rec) => handleShow(rec),
                      show: () => true,
                      disabled: () => false,
                    },
                    {
                      key: 'delete',
                      title: 'Deletar',
                      icon: <DeleteIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: () => false,
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoCreateEdit ref={refDialogoCreateEdit} handleClose={handleClose} />
      <DialogoDeletar ref={refDialogoDeletar} handleClose={handleClose} />
      <DialogoShow ref={refDialogoShow} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Conferências de Produtos"
    />
  </ProtegerPagina>
);

export default List2;
